/**
 * @module plugins/mask
 * @requires module:common/classes/plugin~Plugin
 * @requires module:modules/mask~Mask
 */
import { Plugin } from '@/common';
import { Mask } from '@/modules';

/**
 * @extends module:common/classes/plugin~Plugin
 * @inheritdoc
 * @classdesc Плагин для маски на полях ввода
 * @hideconstructor
 * @example
 * <!-- Добавит на поле ввода маску телефонного номера -->
 * <div data-mask="phoneNumber">
 *  <input type="text" />
 * </div>
 */
class MaskPlugin extends Plugin {
  /**
   * @description Инициализация плагина.
   * Вызывает {@link module:modules/mask~Mask.maskInput} для каждого
   * элемента с атрибутом <code>[data-mask]</code> с параметром
   * <code>mask</code> из <code>dataset</code>
   */
  static init() {
    const elements = [...document.querySelectorAll('[data-mask]')];
    elements.forEach((element) => {
      const { mask } = element.dataset;
      Mask.maskInput(element, mask);
    });
  }
}
MaskPlugin.config = {};

export default MaskPlugin;
